export default __webpack_public_path__ + "static/media/Black_-_13495_bugbes.11534cb6.mp4";